export type AOPIdSourceFormFields = {
  task_id?: string;
  student_id?: string;
  fieldEmail?: boolean;
  userEmail?: string;
};

export const AOP_ID_SOURCE_DEFAULT_VALUES: Required<AOPIdSourceFormFields> = {
  task_id: "",
  student_id: "",
  fieldEmail: false,
  userEmail: "",
};
